module.exports = __webpack_public_path__ + "static/media/ic_template_0.001c698a.png";